import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { FarmController } from 'src/controllers/farm.controller'
import { CreateFarmConfigDTO } from 'src/dto/farm.dto'

const farmController = new FarmController()

export function useCreateFarmConfig() {
  return useMutation({
    mutationKey: ['createFarmConfig'],
    mutationFn: (payload: CreateFarmConfigDTO) => farmController.createFarmConfig(payload),
    onError: () => {
      toast.error('Erro ao criar configuração da propriedade.')
    }
  })
}
